import { render, staticRenderFns } from "./loading-icon.vue?vue&type=template&id=0203e573&scoped=true&"
import script from "./loading-icon.vue?vue&type=script&lang=js&"
export * from "./loading-icon.vue?vue&type=script&lang=js&"
import style0 from "./loading-icon.vue?vue&type=style&index=0&id=0203e573&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0203e573",
  null
  
)

export default component.exports